module.exports = __webpack_public_path__ + "static/media/06(4).8fe12363.jpg";